import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';
import { PLATFORM_CHAT_SESSIONS_PAGE_SIZE } from '../platformChatConstants';

export function usePlatformChatUnpinnedSessionsInfiniteQuery(
  search: string,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const normalizedSearch = search.trim();
  const isEnabled = (options?.enabled ?? true) && Boolean(user);

  return useInfiniteQuery({
    queryKey: chatQueryKeys.unpinnedSessions(normalizedSearch),
    enabled: isEnabled,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      platformChatService.listUnpinnedSessions({
        limit: PLATFORM_CHAT_SESSIONS_PAGE_SIZE,
        offset: pageParam,
        ...(normalizedSearch.length > 0 ? { search: normalizedSearch } : {}),
      }),
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.length === PLATFORM_CHAT_SESSIONS_PAGE_SIZE
        ? (lastPageParam as number) + PLATFORM_CHAT_SESSIONS_PAGE_SIZE
        : undefined,
  });
}
